import { useState, useEffect } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { StarIcon } from '@heroicons/react/20/solid'
import {
    ShieldCheckIcon,
    HeartIcon,
    AcademicCapIcon,
    CheckBadgeIcon,
    ClockIcon,
    UserGroupIcon,
    SparklesIcon as SparklesIconOutline,
    Bars3Icon,
    XMarkIcon,
    MapPinIcon,
    UserIcon,
} from '@heroicons/react/24/outline'

import logo from "./img/logo.svg"
// import placeholderBlur from "./img/placeholder-blur.jpg"
// import tesimonial1 from "./img/testimonial-1.jpg"
// import tesimonial2 from "./img/testimonial-2.jpg"
// import tesimonial3 from "./img/testimonial-3.jpg"

import './landing.scss'
import axios from 'axios'
// import './tailwind.scss'



const features = [
    {
        name: 'Verified Professionals',
        description: 'All caregivers are thoroughly vetted and certified',
        icon: ShieldCheckIcon,
    },
    {
        name: 'Compassionate Care',
        description: 'Dedicated to providing empathetic, person-centered care',
        icon: HeartIcon,
    },
    {
        name: 'Continuous Training',
        description: 'Regular skill development and education programs',
        icon: AcademicCapIcon,
    },
]

export default function CaregiverProfiles() {
    const [showStickyHeader, setShowStickyHeader] = useState(false)
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
    const [caregivers, setCaregivers] = useState([])
    const [reviews, setReviews] = useState([])
    const [isAuthenticated, setIsAuthenticated] = useState(false)
    const navigate = useNavigate()

    const { type } = useParams()

    useEffect(() => {
        if (type !== 'caregiver' && type !== 'partner' && type !== 'customer') {
            navigate(`/`)
        }
    }, [type])

    useEffect(() => {
        document.body.classList.add("tailwind-body");

        return () => {
            document.body.classList.remove("tailwind-body");
        };
    }, []);

    useEffect(() => {
        const htmlElement = document.documentElement;
        htmlElement.classList.add("tailwind-html");

        return () => {
            htmlElement.classList.remove("tailwind-html");
        };
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY
            setShowStickyHeader(scrollPosition > 200)
        }

        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    useEffect(() => {
        axios.get('/providers')
            .then((res) => {
                setCaregivers(res.data)
            })
            .catch((err) => {
                console.log(err, 'err')
            })
    }, [])

    useEffect(() => {
        const token = localStorage.getItem('token')
        setIsAuthenticated(!!token)
    }, [])

    return (
        <div className="min-h-screen bg-gradient-to-b from-sky-50 via-white to-sky-50 rounded-3xl md:m-5">
            {/* Sticky Header */}
            <div className={`fixed inset-x-0 top-4 z-50 flex justify-center transition-all duration-300 ${showStickyHeader ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'
                }`}>
                <nav className="w-full max-w-[600px] mx-4 flex items-center justify-between rounded-full bg-white/80 backdrop-blur-md shadow-md shadow-sky-900/5 ring-1 ring-slate-200 px-5 py-4">
                    <Link to="/" className="flex items-center space-x-2">
                        <img
                            src={logo}
                            alt="Emissary Care"
                            className="h-8 w-auto"
                        />
                    </Link>
                    {/* Desktop Navigation */}
                    <div className="hidden md:flex items-center gap-x-8">
                        <Link to="/about" className="text-sm font-semibold leading-6 text-slate-900 hover:text-blue-600 transition-colors duration-200">
                            About Us
                        </Link>
                        <Link to="/about/how" className="text-sm font-semibold leading-6 text-slate-900 hover:text-blue-600 transition-colors duration-200">
                            How It Works
                        </Link>
                        <div className="flex items-center gap-x-4 pl-8 border-l border-gray-200">
                            {isAuthenticated ? (
                                <Link
                                    to="/profile"
                                    className="inline-flex items-center gap-2 text-sm font-semibold leading-6 text-slate-900 hover:text-blue-600 transition-colors duration-200"
                                >
                                    <UserIcon className="h-5 w-5" />
                                    My Profile
                                </Link>
                            ) : (
                                <>
                                    <Link
                                        to="/auth/login"
                                        className="text-sm font-semibold leading-6 text-slate-500 hover:text-blue-600 transition-colors duration-200"
                                    >
                                        Log in
                                    </Link>
                                    <button
                                        onClick={() => navigate(`/auth/${type}/signup`)}
                                        className="group relative rounded-full px-5 py-2 text-sm font-semibold"
                                    >
                                        <span className="absolute inset-0 rounded-full bg-blue-500 transition-all duration-200 ease-in-out group-hover:bg-blue-600"></span>
                                        <span className="absolute inset-0 rounded-full ring-2 ring-blue-400/40 transition-all duration-200 ease-in-out group-hover:ring-blue-500/40"></span>
                                        <span className="relative text-white">Sign up</span>
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                    {/* Mobile Menu Button */}
                    <button
                        type="button"
                        className="md:hidden inline-flex items-center justify-center rounded-md text-slate-700 hover:text-blue-600 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500"
                        onClick={() => setIsMobileMenuOpen(true)}
                    >
                        <span className="sr-only">Open main menu</span>
                        <Bars3Icon className="h-6 w-6" aria-hidden="true" />
                    </button>
                </nav>

                {/* Mobile menu overlay */}
                <div
                    className={`fixed inset-0 z-50 transition-opacity duration-300 ${isMobileMenuOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
                        }`}
                >
                    <div className="fixed inset-0 bg-slate-900/20 backdrop-blur-sm" aria-hidden="true" onClick={() => setIsMobileMenuOpen(false)} />
                    <div className={`fixed inset-y-0 inset-x-0 bg-white shadow-2xl transition-transform duration-300 ease-in-out ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
                        }`}>
                        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200">
                            <Link to="/" className="flex items-center space-x-2" onClick={() => setIsMobileMenuOpen(false)}>
                                <img
                                    src={logo}
                                    alt="Emissary Care"
                                    className="h-8 w-auto"
                                />
                            </Link>
                            <button
                                type="button"
                                className="rounded-full p-2 text-slate-500 hover:text-blue-600 hover:bg-slate-100 transition-all duration-200"
                                onClick={() => setIsMobileMenuOpen(false)}
                            >
                                <span className="sr-only">Close menu</span>
                                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                            </button>
                        </div>
                        <div className="px-6 py-8 space-y-8 bg-white h-[calc(100vh-72px)] overflow-y-auto">
                            <div className="space-y-5">
                                <Link
                                    to="/about"
                                    className="flex items-center gap-x-2 text-base font-medium text-slate-800 hover:text-blue-600 transition-colors duration-200"
                                    onClick={() => setIsMobileMenuOpen(false)}
                                >
                                    <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-slate-100 ring-1 ring-slate-200">
                                        <UserGroupIcon className="h-5 w-5 text-slate-600" />
                                    </div>
                                    About Us
                                </Link>
                                <Link
                                    to="/about/how"
                                    className="flex items-center gap-x-2 text-base font-medium text-slate-800 hover:text-blue-600 transition-colors duration-200"
                                    onClick={() => setIsMobileMenuOpen(false)}
                                >
                                    <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-slate-100 ring-1 ring-slate-200">
                                        <SparklesIconOutline className="h-5 w-5 text-slate-600" />
                                    </div>
                                    How It Works
                                </Link>
                            </div>
                            <div className="space-y-5 pt-6 border-t border-slate-200">
                                {isAuthenticated ? (
                                    <Link
                                        to="/profile"
                                        className="flex items-center gap-x-2 text-base font-medium text-slate-800 hover:text-blue-600 transition-colors duration-200"
                                        onClick={() => setIsMobileMenuOpen(false)}
                                    >
                                        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-slate-100 ring-1 ring-slate-200">
                                            <UserIcon className="h-5 w-5 text-slate-600" />
                                        </div>
                                        My Profile
                                    </Link>
                                ) : (
                                    <>
                                        <Link
                                            to="/auth/login"
                                            className="flex items-center gap-x-2 text-base font-medium text-slate-800 hover:text-blue-600 transition-colors duration-200"
                                            onClick={() => setIsMobileMenuOpen(false)}
                                        >
                                            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-slate-100 ring-1 ring-slate-200">
                                                <UserGroupIcon className="h-5 w-5 text-slate-600" />
                                            </div>
                                            Log in
                                        </Link>
                                        <button
                                            className="flex items-center justify-between w-full rounded-xl bg-blue-500 px-6 py-3 text-base font-semibold text-white shadow-sm hover:bg-blue-600 transition-colors duration-200 group"
                                            onClick={() => { setIsMobileMenuOpen(false); navigate(`/auth/${type}/signup`) }}
                                        >
                                            Sign up
                                            <SparklesIconOutline className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-0.5" />
                                        </button>
                                    </>
                                )}
                            </div>
                            <div className="pt-6 border-t border-slate-200">
                                <div className="rounded-xl bg-slate-50 p-4 ring-1 ring-slate-200">
                                    <p className="text-sm text-slate-600">
                                        Now serving Massachusetts, New Hampshire, and Florida
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Regular Header */}
            <header className="relative z-40">
                <nav className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8" aria-label="Global">
                    <div className="flex lg:flex-1">
                        <Link to="/" className="flex items-center space-x-2">
                            <img
                                src={logo}
                                alt="Emissary Care"
                                className="h-10 w-auto"
                            />
                        </Link>
                    </div>
                    <div className="hidden lg:flex lg:flex-1 lg:justify-center">
                        <div className="flex gap-x-12">
                            <Link to="/about" className="text-sm font-medium leading-6 text-slate-600 hover:text-blue-600 transition-colors duration-200">
                                About Us
                            </Link>
                            <Link to="/about/how" className="text-sm font-medium leading-6 text-slate-600 hover:text-blue-600 transition-colors duration-200">
                                How It Works
                            </Link>
                        </div>
                    </div>
                    <div className="flex lg:flex-1 lg:justify-end">
                        <div className="flex items-center gap-x-4">
                            {isAuthenticated ? (
                                <Link
                                    to="/profile"
                                    className="inline-flex items-center gap-2 text-sm font-medium leading-6 text-slate-900 hover:text-blue-600 transition-colors duration-200"
                                >
                                    <UserIcon className="h-5 w-5" />
                                    My Profile
                                </Link>
                            ) : (
                                <>
                                    <Link
                                        to="/auth/login"
                                        className="text-sm font-medium leading-6 text-slate-500 hover:text-blue-600 transition-colors duration-200"
                                    >
                                        Log in
                                    </Link>
                                    <button
                                        onClick={() => navigate(`/auth/${type}/signup`)}
                                        className="group relative rounded-lg px-4 py-2 text-sm font-semibold"
                                    >
                                        <span className="absolute inset-0 rounded-lg bg-blue-500 transition-all duration-200 ease-in-out group-hover:bg-blue-600"></span>
                                        <span className="absolute inset-0 rounded-lg ring-2 ring-blue-400/40 transition-all duration-200 ease-in-out group-hover:ring-blue-500/40"></span>
                                        <span className="relative text-white">Sign up</span>
                                    </button>
                                </>
                            )}
                        </div>
                    </div>
                </nav>
            </header>

            {/* Hero section with animated gradient */}
            <div className="relative isolate">
                <div
                    className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
                    aria-hidden="true"
                >
                    <div
                        className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-sky-300 to-sky-600 opacity-20 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
                        style={{
                            clipPath:
                                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                        }}
                    />
                </div>

                <main>
                    {/* Hero content */}
                    <div className="relative px-6 lg:px-8">
                        <div className="mx-auto max-w-2xl py-12 sm:py-20">
                            <div className="text-center">
                                <h1 className="text-4xl font-bold tracking-tight pb-3 sm:text-6xl bg-gradient-to-r from-blue-500 via-sky-500 to-sky-700 bg-clip-text text-transparent">
                                    Our Trusted Caregivers
                                </h1>
                                <p className="mt-6 text-lg leading-8 text-gray-600">
                                    Meet our experienced and compassionate care professionals
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Features Section */}
                    <div className="mx-auto mt-8 max-w-5xl px-6 lg:px-8">
                        <div className="grid grid-cols-1 gap-8 sm:grid-cols-3">
                            {features.map((feature) => (
                                <div
                                    key={feature.name}
                                    className="relative flex flex-col gap-6 rounded-2xl bg-white p-6 shadow-slate-200/60 shadow-sm ring-1 ring-gray-200 card-hover"
                                >
                                    <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-sky-50 text-sky-600">
                                        <feature.icon className="h-6 w-6" aria-hidden="true" />
                                    </div>
                                    <div>
                                        <h3 className="text-lg font-semibold text-gray-900 bg-gradient-to-r from-blue-500 via-sky-500 to-sky-700 bg-clip-text text-transparent">{feature.name}</h3>
                                        <p className="mt-2 text-gray-600">{feature.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Caregiver Profiles */}
                    <div className="mx-auto mt-24 max-w-7xl px-6 lg:px-8">
                        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
                            {caregivers.map((caregiver) => (
                                <div
                                    key={caregiver._id}
                                    className="flex flex-col overflow-hidden rounded-2xl bg-white shadow-slate-200/60 shadow-lg ring-1 ring-gray-200 card-hover"
                                >
                                    <div className="relative h-48 bg-sky-100">
                                        {caregiver.avatar ? (
                                            <img
                                                src={caregiver.avatar}
                                                alt={`${caregiver.name} ${caregiver.surname}`}
                                                className="h-full w-full object-cover"
                                            />
                                        ) : (
                                            <div className="absolute inset-0 flex items-center justify-center backdrop-blur-sm">
                                                <span className="text-slate-300 text-lg font-medium">Photo Available After Sign Up</span>
                                            </div>
                                        )}
                                    </div>
                                    <div className="flex flex-1 flex-col justify-between gap-6 p-6">
                                        <div className="flex-1">
                                            <div className="flex items-center justify-between">
                                                <p className="text-sm font-medium text-sky-600">
                                                    {caregiver.cost?.[0]?.title || 'Caregiver'}
                                                </p>
                                                <span className="inline-flex items-center rounded-full bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                                                    ${caregiver.rate}/hr
                                                </span>
                                            </div>
                                            <h3 className="mt-2 text-xl font-semibold text-gray-900">
                                                {caregiver.name} {caregiver.surname}
                                            </h3>
                                            <p className="mt-3 text-base text-gray-500">{caregiver.about}</p>

                                            <div className="mt-6 border-t border-gray-100 pt-4">
                                                <div className="flex items-center text-sm text-gray-500">
                                                    <UserGroupIcon className="mr-2 h-5 w-5 text-gray-400" />
                                                    {caregiver.languages?.primary}
                                                    {caregiver.languages?.secondary && `, ${caregiver.languages.secondary}`}
                                                </div>
                                                <div className="mt-2 flex items-center text-sm text-gray-500">
                                                    <ClockIcon className="mr-2 h-5 w-5 text-gray-400" />
                                                    {caregiver.availabilities?.length > 0 ? `${caregiver.availabilities.length} availability slots` : 'No availability set'}
                                                </div>
                                            </div>

                                            <div className="mt-4 flex flex-wrap gap-2">
                                                {caregiver.isAddressVerified && (
                                                    <span className="inline-flex items-center rounded-full bg-sky-50 px-3 py-1 text-xs font-medium text-sky-700 ring-1 ring-inset ring-sky-600/10">
                                                        Address Verified
                                                    </span>
                                                )}
                                                {caregiver.isPhoneVerified && (
                                                    <span className="inline-flex items-center rounded-full bg-sky-50 px-3 py-1 text-xs font-medium text-sky-700 ring-1 ring-inset ring-sky-600/10">
                                                        Phone Verified
                                                    </span>
                                                )}
                                                {caregiver.overnight && (
                                                    <span className="inline-flex items-center rounded-full bg-sky-50 px-3 py-1 text-xs font-medium text-sky-700 ring-1 ring-inset ring-sky-600/10">
                                                        Overnight Care
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Reviews Section */}
                    <div className="mx-auto mt-32 max-w-7xl px-6 lg:px-8">
                        <div className="mx-auto max-w-2xl text-center">
                            <h2 className="text-3xl font-bold tracking-tight pb-1 text-gray-900 bg-gradient-to-r from-blue-500 via-sky-500 to-sky-700 bg-clip-text text-transparent">
                                What Our Clients Say
                            </h2>
                            <p className="mt-4 text-lg leading-8 text-gray-600">
                                Read about the experiences of families who have found their perfect care match
                            </p>
                        </div>
                        <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-8 text-sm leading-6 sm:mt-20 sm:grid-cols-2 xl:mx-0 xl:max-w-none xl:grid-cols-3">
                            {reviews.map((review) => (
                                <div
                                    key={review.id}
                                    className="relative flex flex-col gap-6 rounded-2xl bg-white/50 p-8 backdrop-blur-sm ring-1 ring-slate-200/70 shadow-sm transition duration-300 hover:bg-gradient-to-b hover:from-white hover:to-sky-50/50"
                                >
                                    <div className="flex items-center gap-x-2">
                                        <div className="flex items-center">
                                            {[...Array(review.rating)].map((_, i) => (
                                                <StarIcon key={i} className="h-5 w-5 text-yellow-400" />
                                            ))}
                                        </div>
                                        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-sky-100">
                                            <CheckBadgeIcon className="h-4 w-4 text-sky-600" aria-hidden="true" />
                                        </div>
                                    </div>
                                    <div className="relative">
                                        <svg
                                            className="absolute -top-3 -left-3 h-8 w-8 -translate-x-2 -translate-y-2 transform text-slate-200"
                                            fill="currentColor"
                                            viewBox="0 0 32 32"
                                            aria-hidden="true"
                                        >
                                            <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
                                        </svg>
                                        <p className="relative text-base text-slate-600">{review.content}</p>
                                    </div>
                                    <div className="relative mt-auto flex items-center justify-between border-t border-slate-200 pt-6">
                                        <div>
                                            <div className="font-display text-base font-medium text-slate-900">
                                                {review.author}
                                            </div>
                                            <div className="mt-1 text-sm text-slate-500">
                                                {review.credential}
                                            </div>
                                        </div>
                                        <div className="overflow-hidden rounded-full bg-slate-50 ring-1 ring-slate-200/60">
                                            <div className="h-8 w-8 object-cover grayscale filter">
                                                <div className="h-full w-full rounded-full bg-gradient-to-br from-sky-400 to-sky-200 opacity-30" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Sign Up CTA */}
                    <div className="relative isolate px-6 py-24 sm:py-12 lg:px-8 mt-12">
                        <div className="absolute inset-x-0 top-1/2 -z-10 -translate-y-1/2 transform-gpu overflow-hidden opacity-30 blur-3xl">
                            <div
                                className="ml-[max(50%,38rem)] aspect-[1313/771] w-[82.0625rem] bg-gradient-to-tr from-sky-300 to-sky-600"
                                style={{
                                    clipPath:
                                        'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                                }}
                            />
                        </div>
                        <div className="mx-auto max-w-5xl">
                            <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
                                {/* Left side: Main CTA */}
                                <div className="relative rounded-3xl bg-white/80 backdrop-blur-sm p-8 overflow-hidden flex items-center">
                                    <div className="relative flex-1">
                                        <div className="inline-flex items-center rounded-full bg-sky-100 px-3 py-1 text-sm font-medium text-sky-600 ring-1 ring-inset ring-sky-200">
                                            Limited Time Offer
                                        </div>
                                        <h2 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 bg-gradient-to-r from-blue-500 via-sky-500 to-sky-700 bg-clip-text text-transparent">
                                            Find Your Perfect Caregiver Match
                                        </h2>
                                        <p className="mt-4 text-lg text-gray-600">
                                            Join our community today and get personalized care recommendations based on your specific needs.
                                        </p>
                                        <div className="mt-8 flex flex-col gap-4 sm:flex-row sm:items-center">
                                            <button
                                                onClick={() => navigate(`/auth/${type}/signup`)}
                                                className="group relative rounded-full py-3 px-6 text-sm font-semibold"
                                            >
                                                <span className="absolute inset-0 rounded-full bg-blue-500 transition-all duration-200 ease-in-out group-hover:bg-blue-600"></span>
                                                <span className="absolute inset-0 rounded-full ring-2 ring-blue-400/40 transition-all duration-200 ease-in-out group-hover:ring-blue-500/40"></span>
                                                <span className="relative flex items-center gap-2 text-white">
                                                    Get Started Now
                                                    <SparklesIconOutline className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" />
                                                </span>
                                            </button>
                                            <div className="flex items-center gap-4">
                                                <div className="hidden sm:block h-6 w-px bg-slate-200" />
                                                <Link
                                                    to="/about/how"
                                                    className="inline-flex items-center gap-2 text-sm font-semibold text-slate-600 hover:text-blue-600 transition-colors duration-200"
                                                >
                                                    Learn how it works
                                                    <SparklesIconOutline className="h-4 w-4" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Right side: Benefits */}
                                <div className="relative rounded-3xl bg-gradient-to-br from-sky-500 to-blue-600 p-8 shadow-xl shadow-sky-900/5 overflow-hidden">
                                    <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-white/0" />
                                    <div className="relative">
                                        <h3 className="text-xl font-semibold text-white text-left">
                                            Why Choose Emissary Care?
                                        </h3>
                                        <div className="mt-8 space-y-6">
                                            {[
                                                {
                                                    title: 'Verified Professionals',
                                                    description: 'All caregivers undergo thorough background checks and skill assessments',
                                                    icon: ShieldCheckIcon,
                                                },
                                                {
                                                    title: 'Personalized Matching',
                                                    description: 'Advanced matching system to find the perfect caregiver for your needs',
                                                    icon: SparklesIconOutline,
                                                },
                                                {
                                                    title: 'Flexible Scheduling',
                                                    description: 'Choose from full-time, part-time, or as-needed care options',
                                                    icon: ClockIcon,
                                                },
                                            ].map((benefit, index) => (
                                                <div key={benefit.title}>
                                                    <div className="flex gap-4 items-start">
                                                        <div className="flex-none mt-1">
                                                            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-white/10 ring-1 ring-white/20">
                                                                <benefit.icon className="h-5 w-5 text-white" />
                                                            </div>
                                                        </div>
                                                        <div className="flex-1 text-left">
                                                            <h4 className="text-base font-medium text-white">
                                                                {benefit.title}
                                                            </h4>
                                                            <p className="mt-1 text-sm text-sky-100">
                                                                {benefit.description}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    {index < 2 && (
                                                        <div className="my-6 h-px bg-white/10" aria-hidden="true" />
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                        <div className="mt-8 rounded-2xl bg-white/10 p-6 ring-1 ring-white/20">
                                            <div className="relative">
                                                <svg
                                                    className="absolute -top-2 -left-2 h-8 w-8 -translate-x-2 -translate-y-2 transform text-white/20"
                                                    fill="currentColor"
                                                    viewBox="0 0 32 32"
                                                    aria-hidden="true"
                                                >
                                                    <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
                                                </svg>
                                                <p className="relative text-sm text-sky-100 text-left">
                                                    "Emissary Care made finding the right caregiver simple and stress-free. The quality of care has been exceptional."
                                                </p>
                                                <div className="mt-3 text-sm text-sky-200 flex items-center gap-2">
                                                    <span>— Sarah M., Boston</span>
                                                    <CheckBadgeIcon className="h-4 w-4 text-sky-200" aria-hidden="true" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    )
} 